import DashboardStat from '@shared/ui/dashboard/DashboardStat';
import { ListData } from '@shared/ui/parts';
import { useSelector } from 'react-redux';
import { formatBalanceUi } from '@utils/balance-helpers';
import { useTranslation } from 'react-i18next';
import { useMemo } from 'react';
import { donutChartOptions } from '@utils/charts-helpers';
import { ThemeButtonIcon } from '@shared/ui/buttons';
import { useActiveCardsDialog } from '@utils/dialogs-hooks';

export default function DashboardTotalBalance() {
  const { t } = useTranslation();
  const { openActiveCardsDialog } = useActiveCardsDialog();
  const { totalBalance, masterBalance, binBalance } = useSelector(
    (state) => state.bankWallets,
  );

  const listData = [
    {
      label: t('Master balance'),
      value: formatBalanceUi(masterBalance, 'USD'),
      balance: 'master',
    },
    {
      label: t('bin_balance'),
      value: formatBalanceUi(binBalance, 'USD'),
      balance: 'bin',
    },
  ];

  const chartData = useMemo(() => {
    const isEmpty = totalBalance === 0;
    const series = isEmpty ? [1] : [masterBalance, binBalance];
    const colors = isEmpty
      ? ['var(--basic-sep)']
      : ['var(--brand-primary-accent)', 'var(--brand-primary-text)'];
    return {
      series,
      options: {
        ...donutChartOptions.options,
        colors,
      },
    };
  }, [totalBalance, masterBalance, binBalance]);

  return (
    <div className="dashboardStat__block">
      <DashboardStat
        title={t('total_balance')}
        chartData={chartData}
        value={formatBalanceUi(totalBalance, 'USD', null, true)}
      />
      <div className="dashboardStat__cardsView">
        <ListData listData={listData} />
        <ThemeButtonIcon icon="view-cards" onClick={openActiveCardsDialog} />
      </div>
    </div>
  );
}
